module.exports = __webpack_public_path__ + "static/media/be-good-interreg-nwe-vertical.ec4477fa.jpg";